module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAVCAMAAACuRUSFAAAAV1BMVEUAAABVYXdUYXdWYnhVYXhJUm1UYndVYndVYndUYXhTZHVVW3ZVYnZVY3dVYndVYnhVYndUYXZVYXdWYndVYXdVYnZUYXdVYndVYXdVYnZVYXdUYnZVYndTx15XAAAAHHRSTlMA9JBxFQflmX4oHQ3c1MSwrJ+EZWFOO+rHwLiIo44wbQAAAGtJREFUGNNdjlcSgCAMRLHQLYiILfc/p2bGiYT9y4PZt0KIsIoyLYApzghvFk93B5ipJ7A1CAZLwCoEeybgRgTNr/EzYCKTokZWmqOvflz1DPaqJes33J/YPpX5fseKTxLfXzFFY3ERGVJxPa2sC6VObWFYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newsCenter/right@2x.png
// module id = xy9m
// module chunks = 44